import knowledgeData from "../../data/dashboardKnowledge.json";
import {
  DashboardKnowledgeArticle,
  DashboardKnowledgeData,
} from "app/types/dashboardKnowledge";

const parsed = knowledgeData as DashboardKnowledgeData;

export const DASHBOARD_KNOWLEDGE_ARTICLES: DashboardKnowledgeArticle[] =
  parsed.articles ?? [];

export function filterKnowledgeArticles(
  query: string,
  articles: DashboardKnowledgeArticle[] = DASHBOARD_KNOWLEDGE_ARTICLES
): DashboardKnowledgeArticle[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return articles;
  }

  return articles.filter((article) => {
    const haystack = [
      article.title,
      article.subtitle,
      ...(article.keywords ?? []),
    ]
      .join(" ")
      .toLowerCase();

    return haystack.includes(normalizedQuery);
  });
}

export function hasKnowledgeVideo(article: DashboardKnowledgeArticle): boolean {
  return Boolean(article.videoUrl?.trim());
}
